var map = {
	"./loma-real-inn/dark-logo.webp": 7120,
	"./loma-real-inn/light-logo.webp": 2168,
	"./loma-real-pacific/dark-logo.webp": 4768,
	"./loma-real-pacific/light-logo.webp": 4824,
	"./loma-real-resort/dark-logo.webp": 9062,
	"./loma-real-resort/light-logo.webp": 4718,
	"./mansion/dark-logo.webp": 3625,
	"./mansion/light-logo.webp": 6391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3557;